import { useQuery } from 'react-query'
import callAPI from '../../API/callSecureAPI'
import endpoints from '../../API/endpoints'
import { useAuth0 } from '../../contexts/auth0-context'
import { useStrategy } from '../hooks/useStrategy'

export type SnapshotJobItem = {
    _id: string
    isSnapshotJob: true
    status: 'in_progress' | 'failed'
    error?: string
    sourceStrategyId: string
    createdAt: string
    creatorName?: string
}

export type CompletedSnapshotItem = {
    _id: string
    isSnapshotJob?: never
    snapshotNote?: string
    creatorName?: string
    snapshotCreatorId?: string
    sourceId: string
    createdAt: string
}

export type SnapshotListItem = SnapshotJobItem | CompletedSnapshotItem

export const SNAPSHOTS_QUERY_KEY = 'snapshots'

export const useGetSnapshotsQuery = () => {
    const { getTokenSilently } = useAuth0()
    const strategy = useStrategy()
    const sourceId: string | undefined = strategy?.sourceId ?? strategy?._id

    return useQuery<SnapshotListItem[]>(
        [SNAPSHOTS_QUERY_KEY, sourceId],
        async () => {
            const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
            const response = await callAPI(
                endpoints.getStrategy.url + '?sourceId=' + sourceId,
                endpoints.getStrategy.method,
                token
            )
            if (!response.success) throw new Error('Failed to fetch snapshots')
            return response.data
        },
        {
            enabled: !!sourceId,
            refetchInterval: (data) => {
                const hasInProgress = data?.some((item) => item.isSnapshotJob === true && item.status === 'in_progress')
                return hasInProgress ? 20000 : false
            },
        }
    )
}

export const useHasInProgressSnapshot = (): boolean => {
    const { data } = useGetSnapshotsQuery()
    return data?.some((item) => item.isSnapshotJob === true && item.status === 'in_progress') ?? false
}
